import { render, staticRenderFns } from "./OrderManager.vue?vue&type=template&id=a5a9a020&scoped=true"
import script from "./OrderManager.vue?vue&type=script&lang=js"
export * from "./OrderManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a9a020",
  null
  
)

export default component.exports